
$(document).ready(function () {

    $('.hero-slider').slick({
        fade: true,
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2000, 
        arrows: false,
        dots: false,
        speed: 800,
        pauseOnHover: false
    });

    $('.slick-pause').on('click', function () {
        var slider = $('.hero-slider');
        var icon = $(this).find('i');

        if (icon.hasClass('fa-pause')) {
            slider.slick('slickPause');
            icon.removeClass('fa-pause').addClass('fa-play');
        } else {
            slider.slick('slickPlay');
            icon.removeClass('fa-play').addClass('fa-pause');
        }
    });

    $('.hero-slider').on('afterChange', function (event, slick, currentSlide) {
        $('.slider-counter').text(
            (currentSlide + 1).toString().padStart(2, '0') +
            ' / ' +
            slick.slideCount.toString().padStart(2, '0')
        );
    });

    var slickObj = $('.hero-slider').slick('getSlick');
    $('.slider-counter').text(
        '01 / ' + slickObj.slideCount.toString().padStart(2, '0')
    );

});





  const searchBtn = document.querySelector('.search-btn');
  const searchOverlay = document.getElementById('searchOverlay');
  const searchClose = document.getElementById('searchClose');

  searchBtn.addEventListener('click', () => {
    searchOverlay.classList.add('active');
  });

  searchClose.addEventListener('click', () => {
    searchOverlay.classList.remove('active');
  });

  // Close on ESC
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      searchOverlay.classList.remove('active');
    }
  });
